import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";

const ItemListModalDc = ({ showModal, closeModal, branch, onSelectItem }) => {
  useAuthRedirect();

  const [searchTerm, setSearchTerm] = useState("");
  const [items, setItems] = useState([]);        // store all items
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!showModal) return;
    const fetchItems = async () => {
      setLoading(true);
      try {
        const res = await axios.get("https://rfs2.infraconsoft.net.in/api/dc_items", {
          params: { branchcode: branch },
        });
        // Normalize response shape (array or object)
        const data = Array.isArray(res.data)
          ? res.data
          : res.data?.items || res.data?.recordset || [];
        setItems(data);
      } catch (err) {
        console.error("Error fetching items:", err);
        setItems([]);
      } finally {
        setLoading(false);
      }
    };
    fetchItems();
  }, [showModal, branch]);

  const filteredItems = useMemo(() => {
    const q = searchTerm.trim().toLowerCase();
    if (!q) return items;
    return items.filter((it) => {
      const code = String(it?.itemmaster_code ?? "").toLowerCase();
      const name = String(it?.itemmaster_name ?? "").toLowerCase();
      return code.includes(q) || name.includes(q);
    });
  }, [searchTerm, items]);

  const handleSelectItem = (item) => {
    onSelectItem(item);
    closeModal();
  };

  if (!showModal) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <h3 className="modal-title">Select Item</h3>

        <div className="search-filter">
          <p>Search Item :</p>
          <input
            type="text"
            className="search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Type code or name..."
          />
        </div>

        {loading && <p className="loading-text">Loading...</p>}

        <div className="search-results">
          <table>
            <thead>
              <tr>
                <th>Item Code</th>
                <th>Item Name</th>
                <th>Select</th>
              </tr>
            </thead>
            <tbody>
              {!loading && filteredItems.length > 0 ? (
                filteredItems.map((item, idx) => (
                  <tr key={`${item.itemmaster_code}-${idx}`}>
                    <td>{item.itemmaster_code}</td>
                    <td>{item.itemmaster_name}</td>
                    <td>
                      <button
                        className="select-btn"
                        onClick={() => handleSelectItem(item)}
                      >
                        Select
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                !loading && (
                  <tr>
                    <td colSpan="3">No results found</td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>

        <button className="close-btn" onClick={closeModal}>
          Close
        </button>
      </div>
    </div>
  );
};

export default ItemListModalDc;
